import { Link } from "react-router";

import { Icon } from "components/icon/Icon";
import { captureEvent } from "components/posthog/customEventCapture";
import { MenuItem } from "models/header/menuItems";
import { useGlobalContext } from "app/store/GlobalContext";

import "./MainMenuFullscreen.scss";

type Props = {
  menuItems: MenuItem[];
  toggleFullScreenMenu: boolean;
  setToggleFullScreenMenu: (value: boolean) => void;
};

export default function MainMenuFullscreen({
  menuItems,
  toggleFullScreenMenu,
  setToggleFullScreenMenu,
}: Props) {
  const { handleNavigation } = useGlobalContext();

  const classes = toggleFullScreenMenu
    ? "fullscreenMenu fullscreenMenuShow"
    : "fullscreenMenu";

  return (
    <>
      <div className={classes}>
        <nav className="px-4 w-100">
          <ul className="p-0 m-0">
            {menuItems.map((item, index) => {
              if (item.component) {
                return (
                  <li
                    onClick={() => {
                      setToggleFullScreenMenu(false);
                      captureEvent(item.title ?? "MenuItem");
                    }}
                    key={index}
                    title={item.info}
                  >
                    {item.component}
                  </li>
                );
              }

              return (
                <li
                  onClick={() => setToggleFullScreenMenu(false)}
                  title={item.info}
                  key={index}
                >
                  <Link
                    to={item.href ?? ""}
                    onClick={(e) => {
                      handleNavigation({
                        url: item.href ?? "",
                        eventTitle: item.title ?? "MenuItem",
                        e: e,
                      });
                    }}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      <button
        className="fullscreenMenuToggle"
        onClick={() => {
          setToggleFullScreenMenu(!toggleFullScreenMenu);
          captureEvent("Main menu full screen click");
        }}
      >
        {toggleFullScreenMenu ? <Icon name="times" /> : <Icon name="bars" />}
      </button>
    </>
  );
}
